<template>
  <div class="container chef-component" id='chef'>
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="section-title">
                <h2>{{title}}</h2>
            </div>
            <div class="chef-text-body">
                <p v-for='p in para' :key='p.p'>
                    {{p.p}}
                </p>
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="chef-img">
            <img :src="image" alt="chef-image">
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Chef',
  data : function () {
    return {
      title : 'meet our chef',
      para : [
        {
            p:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam. Sed commodo nibh ante facilisis bibendum dolor feugiat at. Duis sed dapibus leo nec ornare diam commodo nibh.'
        },
        {
            p:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam. Sed commodo nibh ante facilisis bibendum dolor feugiat at. Duis sed dapibus leo nec ornare.'
        }
      ],
      image:'assets/images/chef.jpg'
    }
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#chef {
	padding: 120px 0;
}
#chef .section-title>h2{text-align: left;}
#chef h2::after {
	bottom: 0;
	margin-left: 0;
	left: 0;
}
#chef img {
	max-width:100%;
}
#chef .chef-img {
	display: inline-block;
	position: relative;
}

.chef-text-body p{
    text-align:left;
}
</style>
